import { useLocation, type Location } from 'react-router';

export type ListNavigationState = {
  from?: {
    pathname?: string;
    search?: string;
  };
};

type LocationLike = Pick<Location, 'pathname' | 'search'>;

type ListBackHrefOptions = {
  defaultHref: string;
  allowed: string[];
};

const isAllowedPath = (pathname: string, allowed: string[]) =>
  allowed.some((base) => pathname === base || pathname.startsWith(`${base}/`));

export const getListNavigationState = (
  location: LocationLike
): ListNavigationState => ({
  from: {
    pathname: location.pathname,
    search: location.search,
  },
});

export const getListBackHref = (
  state: unknown,
  { defaultHref, allowed }: ListBackHrefOptions
) => {
  const from = (state as ListNavigationState | null)?.from;

  if (from?.pathname && isAllowedPath(from.pathname, allowed)) {
    return `${from.pathname}${from.search || ''}`;
  }

  return defaultHref;
};

export const useListBackHref = (options: ListBackHrefOptions) => {
  const location = useLocation();

  return getListBackHref(location.state, options);
};

export const useListNavigationState = () => {
  const location = useLocation();

  return (location.state as ListNavigationState | null) ?? null;
};
